"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateAd = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _connect;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxConnect = require("redux-connect");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _ads = require("../../redux/modules/ads");

var _reactRouterRedux = require("react-router-redux");

var _adFormValidator = require("./adFormValidator");

var _adFormValidator2 = _interopRequireDefault(_adFormValidator);

var _AdForm = require("../../components/ads/AdForm");

var _AdForm2 = _interopRequireDefault(_AdForm);

var _AdSuccessPanel = require("../../components/ads/AdSuccessPanel");

var _AdSuccessPanel2 = _interopRequireDefault(_AdSuccessPanel);

var _projects = require("../../redux/modules/projects");

var _SendInvitationsModal = require("../../components/modal/SendInvitationsModal");

var _SendInvitationsModal2 = _interopRequireDefault(_SendInvitationsModal);

var _DriversList = require("../../components/projects/DriversList");

var _DriversList2 = _interopRequireDefault(_DriversList);

var _license = require("../../redux/modules/license");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateAd = exports.CreateAd = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CreateAd, _Component);

  function CreateAd() {
    (0, _classCallCheck3.default)(this, CreateAd);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CreateAd.__proto__ || (0, _getPrototypeOf2.default)(CreateAd)).call(this));

    _this.toggleSendInvitationsModal = function () {
      _this.setState({
        showSendInvitationsModal: !_this.state.showSendInvitationsModal
      });
    };

    _this.closeSendInvitationsModal = function () {
      _this.setState({ showSendInvitationsModal: false });
    };

    _this.openSendInvitationsModal = function () {
      _this.setState({ showSendInvitationsModal: true });
    };

    _this.state = {
      messageResponseText: "",
      showEditAdDriversModal: false,
      showSendInvitationsModal: false,
      projectId: 0,
      adId: 0,
      isProjectAd: false
    };

    _this.removeDriver = _this.removeDriver.bind(_this);
    _this.addDriver = _this.addDriver.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CreateAd, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetCreateAd();
      this.props.resetProjectAdDrivers();
      this.setState({
        isProjectAd: false,
        adId: 0
      });
      console.info("componentWillUnmount", this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.ads.ad && this.state.adId == 0) {
        console.info("this.props.ads.ad", this.props.ads.ad.id);
        console.info("this.props.ads.project_id", this.props.ads.ad.project_id);

        if (this.props.ads.ad.project_id > 0) {
          var data = {};
          data.ad_id = this.props.ads.ad.id;
          this.props.getAllDriversByProject(data);
          this.setState({
            adId: parseInt(this.props.ads.ad.id)
          });
          var test = this.props.projectAdGetDrivers(this.state.adId);
        }
      }

      if (this.props.projects && this.props.projects.addDriverToAdSuccess) {
        if (this.props.projects.addedDrivers !== prevProps.projects.addedDrivers) {
          console.info("addDriverToAdSuccess", this.props.projects.addedDrivers);
          this.openSendInvitationsModal();
        }
      }

      if (this.props.ads.sendAdMessageResponse) {
        if (this.props.ads.sendAdMessageResponse !== prevProps.ads.sendAdMessageResponse) {
          console.info("sendAdMessageResponse", this.props.ads.sendAdMessageResponse);
          this.setState({
            messageResponseText: this.props.ads.sendAdMessageResponse
          });
        }
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          routeParams = _props.routeParams,
          user = _props.user;

      var projectId = parseInt(routeParams.projectId, 10);

      if (projectId > 0) {
        this.setState({
          isProjectAd: true,
          projectId: projectId
        });
      } else {
        this.setState({
          isProjectAd: false,
          projectId: 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          project = _props2.project,
          updateProjectDriverByEmail = _props2.updateProjectDriverByEmail,
          loadProject = _props2.loadProject,
          isProjectLoaded = _props2.isProjectLoaded;
      var isProjectAd = this.state.isProjectAd;

      if (isProjectAd) {
        return _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(_reactHelmet2.default, { title: "PROJEKTI ILMOITUS" }),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(
                "h1",
                { className: "h2" },
                project.business_name,
                ": PROJEKTI ILMOITUS"
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            this.defineContent()
          )
        );
      }
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "J\xE4t\xE4 ilmoitus" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          this.defineContent()
        )
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      var _state = this.state,
          isProjectAd = _state.isProjectAd,
          showSendInvitationsModal = _state.showSendInvitationsModal;
      var _props3 = this.props,
          updateProjectDriverByEmail = _props3.updateProjectDriverByEmail,
          sendAdMessage = _props3.sendAdMessage;


      if (this.props.ads.createAdSuccess) {
        var transfer_request = this.props.fields.transfer_request;
        var ad_type = this.props.fields.ad_type;

        return _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(_AdSuccessPanel2.default, {
            editing: false,
            transferRequestSent: !!transfer_request.value,
            pushRoute: this.props.pushRoute,
            resetState: this.props.resetCreateAd,
            supplierAd: ad_type.value === "supplierAd",
            user: this.props.user,
            ad: this.props.ads.ad
          }),
          isProjectAd ? _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "h2",
              { className: "h4 form-title" },
              "Yrityksen kuljettajat "
            ),
            this.state.messageResponseText,
            // this.props.license.driverLicenses && this.props.projectAdDrivers &&
            _react2.default.createElement(_DriversList2.default, {
              adDriversList: this.props.projectAdDrivers,
              licensedDriversList: this.props.license.allDriverLicenses,
              updateDriverByEmail: updateProjectDriverByEmail,
              projectId: this.state.projectId,
              removeDriver: this.removeDriver,
              addDriver: this.addDriver
            }),
            _react2.default.createElement(_SendInvitationsModal2.default, {
              isShowingModal: showSendInvitationsModal,
              data: this.props.projects.addedDrivers,
              sendAdMessage: sendAdMessage,
              handleClose: this.toggleSendInvitationsModal })
          ) : ""
        );
      }
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_AdForm2.default, (0, _extends3.default)({
          editing: false,
          soilTypes: this.props.ads.soilTypes,
          submitAd: this.props.createAd,
          loading: this.props.ads.createAdLoading || false,
          isProjectAd: isProjectAd
        }, this.props)),
        this.renderErrorMessage()
      );
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var createAdError = this.props.ads.createAdError;


      if (createAdError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-md-6 col-md-offset-6" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            "Ilmoituksen lis\xE4\xE4misess\xE4 tapahtui virhe. Tarkista ett\xE4 olet t\xE4ytt\xE4nyt kaikki vaaditut kent\xE4t."
          )
        );
      }
    }
  }, {
    key: "removeDriver",
    value: function removeDriver(data) {
      console.info("REMOVE DRIVER", data);
      // removeDriverFromAd
      var dataToSent = {
        useNewVersion: true,
        user_id: data.user_id,
        project_id: this.state.projectId,
        ad_id: this.state.adId
      };

      var removeDriverFromAd = this.props.removeDriverFromAd;

      removeDriverFromAd(dataToSent);
    }
  }, {
    key: "addDriver",
    value: function addDriver(data) {
      console.info("ADD DRIVER", data);
      var dataToSent = {
        useNewVersion: true,
        user_id: data.user_id,
        project_id: this.state.projectId,
        email: data.email,
        ad_id: this.state.adId,
        phone: data.phone
      };
      console.info("data to sent", dataToSent);

      var addDriverToAd = this.props.addDriverToAd;

      addDriverToAd(dataToSent);
    }
  }]);
  return CreateAd;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  handleSubmit: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  ads: _react.PropTypes.object,
  createAd: _react.PropTypes.func.isRequired,
  resetCreateAd: _react.PropTypes.func.isRequired,
  resetProjectAdDrivers: _react.PropTypes.func.isRequired,
  project: _react.PropTypes.object,
  isProjectLoaded: _react.PropTypes.func,
  loadProject: _react.PropTypes.func,
  routeParams: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired,
  projectAdDrivers: _react.PropTypes.array,
  projects: _react.PropTypes.object,
  projectAdGetDrivers: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        _ref$params = _ref.params,
        projectId = _ref$params.projectId,
        adId = _ref$params.adId;

    var promises = [];
    if (projectId > 0) {
      promises.push(dispatch((0, _projects.loadProject)(projectId)));
      promises.push(dispatch((0, _projects.loadProjectUsers)(projectId)));
      //   promises.push(dispatch(projectAdGetDrivers(adId)));
    }

    return _promise2.default.all(promises);
  }

}])((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    company: state.company.company,
    ads: state.ads,
    project: state.projects.project,
    projectAdDrivers: state.projects.projectAdDrivers,
    projectUsers: state.projects.projectUsers,
    license: state.license,
    projects: state.projects

  };
}, (_connect = {
  createAd: _ads.createAd,
  resetCreateAd: _ads.resetCreateAd,
  pushRoute: _reactRouterRedux.push
}, (0, _defineProperty3.default)(_connect, "createAd", _ads.createAd), (0, _defineProperty3.default)(_connect, "loadProject", _projects.loadProject), (0, _defineProperty3.default)(_connect, "isProjectLoaded", _projects.isProjectLoaded), (0, _defineProperty3.default)(_connect, "addDriverToAd", _projects.addDriverToAd), (0, _defineProperty3.default)(_connect, "updateProjectDriverByEmail", _projects.updateProjectDriverByEmail), (0, _defineProperty3.default)(_connect, "resetProjectAdDrivers", _projects.resetProjectAdDrivers), (0, _defineProperty3.default)(_connect, "loadProjectUsers", _projects.loadProjectUsers), (0, _defineProperty3.default)(_connect, "getAllDriversByProject", _license.getAllDriversByProject), (0, _defineProperty3.default)(_connect, "removeDriverFromAd", _projects.removeDriverFromAd), (0, _defineProperty3.default)(_connect, "projectAdGetDrivers", _projects.projectAdGetDrivers), (0, _defineProperty3.default)(_connect, "sendAdMessage", _ads.sendAdMessage), (0, _defineProperty3.default)(_connect, "sendAdMessageResponse", _ads.sendAdMessageResponse), _connect))((0, _reduxForm.reduxForm)({
  form: "createAd",
  fields: ["construction_site_id", "project_id", "ad_type", "builder", "contractor", "latitude", "longitude", "address", "postal_area", "postal_code", "contact_person_name", "contact_person_phone", "contact_person_email", "soil_type_id", "soil_amount", "soil_description", "price", "delivery_time", "delivery_start_date", "delivery_end_date", "validity_duration", "end_date", "notes", "transfer_request", "activated", "ad_visibility", "visibility"],
  validate: _adFormValidator2.default,
  initialValues: {
    latitude: 0.0,
    longitude: 0.0,
    activated: true,
    ad_visibility: "public_Ad"
  }
})(CreateAd)));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Ads/CreateAd.js
 ** module id = 1205
 ** module chunks = 0
 **/